import { Notify } from 'quasar'
import { modelIndexNames, modelPageNames } from 'src/models'
import { TYPE_NAME_TO_MODEL_MAP } from 'src/models/model'

export function notifyAccessDenied () {
  Notify.create({
    message: 'You do not have permission to access this page',
    type: 'negative',
    position: 'top',
    timeout: 2500
  })
}

export function findModelFromParamName (modelCollectionVariableName) {
  return _.find(TYPE_NAME_TO_MODEL_MAP, (klass, _modelTypeName) => {
    return klass.collectionVariableName === modelCollectionVariableName
  })
}

/**
 * For a route that has a 'name' parameter, check if the currentUser is allowed View access
 * to the model with that name. If not, redirect to the admin root page.
 * @type {NavigationGuard}
 */
export function authorizeModelAccess (to, _from, next) {
  const modelClass = findModelFromParamName(to.params?.name)

  if (!modelClass) {
    // Just in case the model is not in the TYPE_NAME_TO_MODEL_MAP, we ignore this check
    next()
    return
  } else if (modelClass.isViewPermitted) {
    next()
    return
  }

  notifyAccessDenied()
  next({ name: 'admin:root' })
}

/**
 * For a route that has a 'name' parameter, check if there is a model index page for that name.
 * @type {NavigationGuard}
 */
export function redirectIfMissingModelIndex (to, _from, next) {
  if (!_.includes(modelIndexNames, to.params?.name)) {
    next({ name: 'admin:root' })
    return
  }

  next()
}

/**
 * For a route that has a 'name' parameter, check if there is a model show/form page for that name.
 * @type {NavigationGuard}
 */
export function redirectIfMissingModelForm (to, _from, next) {
  if (!_.includes(modelPageNames, to.params?.name)) {
    next({ name: 'admin:root' })
    return
  }

  next()
}
